import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";

export type SignInWithOtpInput = {
  email: string;
  // Caller-supplied `next` path. We append it to the callback redirect URL so
  // the user lands where they were trying to go originally.
  next?: string | null;
};

// Wraps supabase.auth.signInWithOtp. Surfaces errors via sonner toast so the
// caller only needs to await the mutation — no extra try/catch + state.
//
// The emailRedirectTo URL points at /auth/callback on the SPA. supabase-js
// has detectSessionInUrl:true so the code exchange is automatic on return.
export function useSignInWithOtp() {
  return useMutation<{ ok: true }, Error, SignInWithOtpInput>({
    mutationFn: async ({ email, next }) => {
      const redirect = new URL("/auth/callback", window.location.origin);
      if (next) redirect.searchParams.set("next", next);
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: { emailRedirectTo: redirect.toString() },
      });
      if (error) {
        toast.error(error.message);
        throw error;
      }
      return { ok: true };
    },
  });
}
